import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { AdminApiService } from '../admin-api.service';
import { SecuritySettings, PasswordPolicy } from '../models';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  standalone: true,
  selector: 'app-settings-page',
  imports: [CommonModule, InputNumberModule, InputSwitchModule, CheckboxModule, ButtonModule, FormsModule, ToastModule],
  styleUrls: ['./settings.page.scss'],
  templateUrl: './settings.page.html'
})
export class SettingsPage {
  api = inject(AdminApiService);
  ms = inject(MessageService);

  sec: SecuritySettings = { id:1, maxFailedAccessAttempts:5, lockoutMinutes:15, maxConcurrentSessions:3, slidingSessionMinutes:30 };
  pwd: PasswordPolicy = { minLength:8, requireUpper:true, requireLower:true, requireDigit:true, requireSymbol:false, rememberLastN:5, expiresInDays:90 };

  ngOnInit() { this.load(); }
  load() {
    this.api.getSecurity().subscribe(s => this.sec = s);
    this.api.getPasswordPolicy().subscribe(p => this.pwd = p);
  }
  saveSecurity() {
    this.api.saveSecurity(this.sec).subscribe({
      next: () => this.ms.add({severity:'success', summary:'تم', detail:'تم حفظ إعدادات الأمان'}),
      error: () => this.ms.add({severity:'error', summary:'خطأ', detail:'تعذر الحفظ'})
    });
  }
  savePolicy() {
    this.api.savePasswordPolicy(this.pwd).subscribe({
      next: () => this.ms.add({severity:'success', summary:'تم', detail:'تم حفظ سياسة كلمة المرور'}),
      error: () => this.ms.add({severity:'error', summary:'خطأ', detail:'تعذر الحفظ'})
    });
  }
}
